import { useMemo } from 'react';
import { EditTreatmentOverviewFormData } from '~/lib/types/notes/EditTreatmentOverviewFormData';
import {
  DiscussionOfWeightAttribute,
  FormAttribute,
  LevelAttribute,
  MedicalStabilityAttribute,
  ModalityAttribute,
  PhaseStageAttribute,
  PsychiatricStabilityAttribute,
  RefeedingRiskAttribute,
  SaferStageAttribute,
} from '../types/treatmentAttributes/treatmentAttributes';
import { getOpenTreatmentAttribute } from '../util/treatmentEpisodes.util';

type UseInitialTreatmentOverviewFormValuesParams = {
  isLoading: boolean;
  discussionOfWeights: DiscussionOfWeightAttribute[];
  forms: FormAttribute[];
  levels: LevelAttribute[];
  medicalStabilities: MedicalStabilityAttribute[];
  modalities: ModalityAttribute[];
  phaseStages: PhaseStageAttribute[];
  psychiatricStabilities: PsychiatricStabilityAttribute[];
  refeedingRisks: RefeedingRiskAttribute[];
  saferStages: SaferStageAttribute[];
};

export const useInitialTreatmentOverviewFormValues = ({
  discussionOfWeights,
  forms,
  levels,
  medicalStabilities,
  modalities,
  phaseStages,
  psychiatricStabilities,
  refeedingRisks,
  saferStages,
}: UseInitialTreatmentOverviewFormValuesParams): EditTreatmentOverviewFormData =>
  useMemo(
    () => ({
      discussionOfWeight:
        getOpenTreatmentAttribute(discussionOfWeights)?.discussionOfWeight,
      form: getOpenTreatmentAttribute(forms)?.form,
      level: getOpenTreatmentAttribute(levels)?.level,
      medicalStability:
        getOpenTreatmentAttribute(medicalStabilities)?.medicalStability,
      modality: getOpenTreatmentAttribute(modalities)?.modality,
      phaseStage: getOpenTreatmentAttribute(phaseStages)?.phaseStage,
      psychiatricStability: getOpenTreatmentAttribute(psychiatricStabilities)
        ?.psychiatricStability,
      refeedingRisk: getOpenTreatmentAttribute(refeedingRisks)?.refeedingRisk,
      saferStage: getOpenTreatmentAttribute(saferStages)?.saferStage,
    }),
    [
      discussionOfWeights,
      forms,
      levels,
      medicalStabilities,
      modalities,
      phaseStages,
      psychiatricStabilities,
      refeedingRisks,
      saferStages,
    ],
  );
